import { Box, Button, InputAdornment, Step, StepLabel, Stepper, TextField, Typography } from "@mui/material";
import { COLOR } from "../../../utils/colors";
import { VIEW } from "../../../utils/breakpoint";
import { AddOutlined } from "@mui/icons-material";
import { GridSearchIcon } from "@mui/x-data-grid";
import ListRobotMapTable from "../robot-map/list-robot-map-table";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapType } from "../../../hooks/map.type";
import { useUnbindMapMutation } from "../../../hooks/config-page/bind-map";

export default function ListRobotMapPage({
  onSubmit,
  onCancel,
  showForBind
}: {
  onSubmit?: (selectedRobotMaps: MapType[]) => void
  onCancel?: () => void,
  showForBind?: boolean
}) {
  const [searchTerm, setSearchTerm] = useState('')
  const navigate = useNavigate()
  const onCreateNew = () => {
    navigate('/config/robot-maps/create')
  }
  const [selectedRobotMaps, setSelectedRobotMaps] = useState<MapType[]>([])
  const onSelectedChange = (selecteds: MapType[]) => {
    setSelectedRobotMaps(selecteds)
  }
  return (
    <Box sx={(theme) => ({
      paddingY: '34px',
      color: COLOR.neutral[900],
      [theme.breakpoints.up(VIEW.PHONE)]: {
        paddingX: '24px',
      },
      [theme.breakpoints.up(VIEW.TABLET)]: {
        paddingX: '44px',
      }
    })}>
      <Box
        sx={{ paddingY: '16px' }}
      >
        <Stepper activeStep={0}>
          {['Select Robot Maps', 'Select Layout Maps', 'Bind Maps'].map((label, index) => {
            const stepProps: { completed?: boolean } = {
              completed: 0 > index + 1
            };
            const labelProps: {
              optional?: React.ReactNode;
            } = {};
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              sx={{
                fontSize: '24px',
                fontWeight: 600,
                color: COLOR.neutral[900]
              }}
            >
              Bind Robot Map GIS Points
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 400,
                color: COLOR.neutral[900],
                opacity: 0.6,
              }}
            >
              Select Robot Map to bind with the Layout Map
            </Typography>
          </Box>
          <Button onClick={() => onCreateNew?.()} variant="outlined" startIcon={<AddOutlined />}>
            Create New
          </Button>
        </Box>
        <Box sx={{ display: 'flex', mt: '10px' }}>
          <TextField
            id="search-store-name"
            variant="outlined"
            size="small"
            placeholder='Search Robot Map'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              flex: 'auto',
              backgroundColor: 'white',
              height: "40px",
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <GridSearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>
      <ListRobotMapTable
        selectable
        search={searchTerm}
        onSelectedChange={(val) => onSelectedChange(val)}
        showForBind={showForBind}
      />
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: '6px', alignItems: 'center', justifyContent: 'end' }}>
        <Button onClick={() => onCancel?.()} variant="outlined">Cancel</Button>
        <Button onClick={() => onSubmit?.(selectedRobotMaps)} disabled={selectedRobotMaps.length === 0} variant="contained">Next</Button>
      </Box>
    </Box>
  )
}